/* DIE STRESS MANAGERIN 2022 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';

// Additonal libraries
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css'; 

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <BrowserRouter>
          <App />
      </BrowserRouter>
  </React.StrictMode>
);